import React from 'react'

const Faq = () => {
  return (
    <div className='faq'>
        <h3>Frequently Asked Questions</h3>

        <div className="question">
            <strong>Lorem ipsum dolor sit amet consectetur adipisicing?</strong>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi modi eos,
              aliquam eaque totam et fugiat? Ad soluta cupiditate rem vero at? Fugiat minima ut quaerat 
              impedit voluptates nobis illo vero dolore aut incidunt nulla totam voluptas odio iure odit 
              repellat recusandae, quisquam corrupti ex voluptate. Recusandae incidunt ut beat.
            </p>
        </div>

        <div className="question">
            <strong>Lorem ipsum dolor sit amet consectetur adipisicing?</strong>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi modi eos,
              aliquam eaque totam et fugiat? Ad soluta cupiditate rem vero at? Fugiat minima ut quaerat 
              impedit voluptates nobis illo vero dolore aut incidunt nulla totam voluptas odio iure odit 
              repellat recusandae, quisquam corrupti ex voluptate. Recusandae incidunt ut beat.
            </p>
        </div>

        <div className="question">
            <strong>Lorem ipsum dolor sit amet consectetur adipisicing?</strong>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi modi eos,
              aliquam eaque totam et fugiat? Ad soluta cupiditate rem vero at? Fugiat minima ut quaerat 
              impedit voluptates nobis illo vero dolore aut incidunt nulla totam voluptas odio iure odit 
              repellat recusandae, quisquam corrupti ex voluptate. Recusandae incidunt ut beat.
            </p>
        </div>
    </div>
  )
}

export default Faq